import React from 'react';
import '../stylesheets/error.css'

function Error() {
    return (
        <div className='error_div'>
            <h1 className='error_text'>Error! page not found</h1>
        </div>
    )
}

export default Error;